module.exports = __webpack_public_path__ + "media/country_flags/mf-0c64eda2.png";